import { ActivityFactory, DataEntityFactory } from "src/app/services";
import { DataEntity } from "../data-entities";
import { ActivityModel, ScreenActivity } from "./activity";

export class ActivityEntityModel {
  activityId: string;
  activityName: string;
  skipActivity?: boolean;
  canSkipActivity: boolean;
  dataEntities: DataEntity[];
  hasEntities: boolean;
}

export class TestInputActivityModel extends ActivityModel {
  activityEntities: ActivityEntityModel[];

  constructor(options?: Partial<TestInputActivityModel>) {
    super(options);

    if(options) {
      if(options.activityEntities) {
        options.activityEntities.forEach(ae => {
          if(ae.dataEntities) {
            ae.dataEntities = ae.dataEntities.map(de => DataEntityFactory.createDataEntity(de.dataEntityTypeCode, de));
          }
        });
      }
      Object.assign(this, options);
    }
  }
}

export class TestInputActivity extends ScreenActivity<ActivityModel> {
  model: TestInputActivityModel;

  constructor(options?: { [key: string]: any }) {
    super(options);

    this.model = new TestInputActivityModel(options ? options.model : null);
  }
}
